module.exports = __webpack_public_path__ + "static/media/Default.fa95eb70.svg";